import {Allegato} from './allegato';
import {Observable} from 'rxjs';

export class News {

    public uuid: string;
    public titolo: string;
    public anteprima: string;
    public testo: string;
    public data_pubblicazione: Date;
    public periodo: string;
    public autore: string;
    public lang: string;

    public immagine_lancio: string;
    public path: string;
    public link: string;
    public allegato: Observable<Allegato>;

    constructor() {

    }
}
